module.exports = __webpack_public_path__ + "static/windshaper-planetar-3ed26286f08c445ffc4ade1f87270b60.webp";